/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from "react";
import useStyles from "./GridFood.style";
import { useRouter } from "next/router";

export interface GridFoodProps {
  imageSrc: string;
  content?: ReactNode;
  style?: React.CSSProperties;
}

const GridFood: React.FC<GridFoodProps> = ({ imageSrc, content, style }) => {
  const { locale } = useRouter();
  const { classes } = useStyles({ params: { locale: locale! } });

  return (
    <div style={style}>
      <img src={imageSrc} alt="Food Image" className={classes.imgGridFood} />
      <p className={classes.ContentFood}>{content}</p>
    </div>
  );
};

export default GridFood;
